//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { eventEmitter } from '@/main.js'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'ticker-tile',
	props: {
		tileKey: {
			type: String,
			required: true,
		},
		tileProps: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		data: [],
		interval: null,
		ticker: null,
		pair: null,
		symbol: null,
		link: null,
		exchange: null,
		loading: false,
	}),
	methods: {
		...mapActions(['getKlines', 'deleteTile']),

		async fetchData() {
			try {
				this.loading = true
				this.data = await this.getKlines({
					exchange: this.exchange,
					symbol: this.symbol,
					pair: this.pair,
					ticker: this.ticker,
					interval: this.interval,
					interval: this.interval,
				})
				this.loading = false
			} catch (e) {
				this.loading = false
				console.warn('Error while executing Global metrics request', e)
			} finally {
				this.loading = false
			}
		},
		removeTile() {
			this.deleteTile(this.key)
		},
		redirect() {
			window.open(this.link)
		},
		async refresh() {
			await this.fetchData(this.exchange, this.symbol, this.interval)
		},
	},
	watch: {
		tileProps: {
			immediate: true,
			async handler(val) {
				if (val) {
					const { exchange, symbol, pair, ticker, interval, link, key } = val
					this.link = link
					this.exchange = exchange
					this.symbol = symbol
					this.ticker = ticker
					this.pair = pair
					this.interval = interval
					await this.fetchData()
				}
			},
		},
	},
	computed: {
		...mapGetters(['theme']),

		isNegativePrice() {
			return this.lastPrice < this.firstPrice ?? false
		},
		lastPrice() {
			return this.chartValues[this.chartValues.length - 1]
		},
		firstPrice() {
			return this.chartValues[0]
		},
		key() {
			return this.tileKey
		},
		chartValues() {
			return this.chartData.map((el) => el.x)
		},
		chartData() {
			return this.data
		},
	},
}
